"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeToggle = void 0;
const theme_toggle_html_1 = __importDefault(require("./templates/theme-toggle.html"));
class ThemeToggle {
    element;
    constructor() {
        this.element = this.createToggle();
        this.initializeTheme();
        this.setupEventListeners();
    }
    createToggle() {
        const container = document.querySelector('.theme-toggle');
        if (container) {
            container.innerHTML = theme_toggle_html_1.default;
            return container.querySelector('button');
        }
        throw new Error('Theme toggle container not found');
    }
    initializeTheme() {
        if (localStorage.getItem('theme') === 'dark' || (!localStorage.getItem('theme') && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
            document.documentElement.classList.add('dark');
            this.updateThemeToDark(true);
            // Optional chaining: if the analytics script is blocked (ad blockers) or slow
            // to load, window.umami is undefined — tracking must never break the site.
            window.umami?.track('Theme', { theme: 'dark' });
        }
        else {
            this.updateThemeToDark(false);
            window.umami?.track('Theme', { theme: 'light' });
        }
    }
    updateThemeToDark(isDark) {
        const themeColorMeta = document.querySelector('meta[name="theme-color"]');
        if (themeColorMeta) {
            themeColorMeta.setAttribute('content', isDark ? '#030712' : '#ffffff');
        }
    }
    setupEventListeners() {
        this.element.addEventListener('click', () => this.toggleTheme());
    }
    toggleTheme() {
        const html = document.documentElement;
        const body = document.body;
        const navbar = document.querySelector('nav');
        const footer = document.getElementById('footer');
        [html, body, navbar, footer].forEach((el) => {
            if (el)
                el.classList.add('transition-colors');
        });
        const isDark = html.classList.toggle('dark');
        localStorage.setItem('theme', isDark ? 'dark' : 'light');
        window.umami?.track('Theme Changed', { theme: isDark ? 'dark' : 'light' });
        this.updateThemeToDark(isDark);
        setTimeout(() => {
            [html, body, navbar, footer].forEach((el) => {
                if (el)
                    el.classList.remove('transition-colors');
            });
        }, 400);
    }
}
exports.ThemeToggle = ThemeToggle;
